module.exports = __webpack_public_path__ + "static/media/SRE007_01.636f665b.jpg";